module.exports = __webpack_public_path__ + "img/h.a224453e.jpg";